import * as React from 'react';

import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { PromoIcon } from './PromoIcon';
import { PromoSubtitle } from './PromoSubtitle';
import { PromoItem } from '../../../components/NewbuildingPromos/parts/PromoItem';
import { IPromoInfo } from '../../../types/newbuildingPromos';
import { trackClickPromoBlock } from '../../../utils/tracking/promos/trackClickPromoBlock';
import { NewbuildingPromoDetailsContainer } from '../../NewbuildingPromoDetails';

interface IPromoProps {
  promo: IPromoInfo;
  offer: IOfferSchema;
  isMainDiscountPromo?: boolean;
}

export function Promo({ promo, offer, isMainDiscountPromo }: IPromoProps) {
  const [open, setOpen] = React.useState(false);

  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  const handlePromoClick = React.useCallback(() => {
    setOpen(true);
    trackClickPromoBlock({ promo, offer });
  }, [promo, offer]);

  return (
    <>
      <PromoItem
        promo={promo}
        onClick={handlePromoClick}
        icon={<PromoIcon promo={promo} />}
        subtitle={<PromoSubtitle promo={promo} />}
        isMainDiscountPromo={isMainDiscountPromo}
      />
      <NewbuildingPromoDetailsContainer open={open} onClose={handleClose} promo={promo} offer={offer} />
    </>
  );
}
